import { CustomThemeOptions } from '../types';
import { ColorMode } from '../ThemeModeContext';

import logoDark from '../../assets/tenants/greentech/logoDark.svg';
import logoLight from '../../assets/tenants/greentech/logoLight.svg';
import logoMain from '../../assets/tenants/greentech/logo.svg';
import authCircleInside from '../../assets/tenants/greentech/InnerCircle.png';
import authCircleOutside from '../../assets/tenants/greentech/ellipse-outside.svg';

export const getGreentechThemeOptions = (mode: ColorMode = 'light'): CustomThemeOptions => {
  const isDark = mode === 'dark';

  return {
    palette: {
      mode,
      primary: isDark
        ? {
            main: '#26a69a',
            light: '#4db6ac',
            dark: '#13675f',
            contrastText: '#ffffff',
          }
        : {
            main: '#134A55',
            light: '#4C7051',
            dark: '#2E3F1E',
            contrastText: '#ffffff',
          },
      secondary: {
        main: isDark ? '#195e56' : '#13675f',
      },
      background: isDark
        ? {
            default: '#0a1012',
            paper: '#162328', // Elevated, lighter blob/card surface
          }
        : {
            default: '#f8fafc',
            paper: '#ffffff',
          },
      text: isDark
        ? {
            primary: '#f1f5f9',
            secondary: '#94a3b8',
          }
        : {
            primary: '#1e293b',
            secondary: '#64748b',
          },
      divider: isDark ? 'rgba(255, 255, 255, 0.09)' : 'rgba(0, 0, 0, 0.08)',
      black: {
        main: '#2B2D2E',
        light: '#515151',
        dark: '#202122',
      },
      white: {
        main: '#EFEFEF',
        light: '#F5F5F5',
        dark: '#E8E8E8',
      },
    },
    typography: {
      button: {
        textTransform: 'none',
      },
      fontFamily: ['Mukta', 'Saira'].join(','),
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 961,
        md: 1200,
        lg: 1200,
        xl: 1536,
      },
    },
    gradients: {
      primary: isDark
        ? 'linear-gradient(90deg, #134a55 0%, #26a69a 100%)'
        : 'linear-gradient(90deg, #134a55 0%, #13675f 100%)',
      secondary: isDark
        ? 'linear-gradient(180deg, #11363e 0%, #162328 100%)'
        : 'linear-gradient(180deg, #134A55 0%, #13675f 100%)',
    },
    media: {
      logos: {
        main: isDark ? logoLight : logoMain,
        light: logoLight,
        dark: logoDark,
      },
      authCircleInside,
      authCircleOutside,
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
            ...(isDark && {
              border: '1px solid rgba(255, 255, 255, 0.08)',
              boxShadow: '0 4px 20px -2px rgba(0, 0, 0, 0.45)',
            }),
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: isDark ? '#162328' : '#ffffff',
            color: isDark ? '#f1f5f9' : '#1e293b',
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: isDark ? '#0e171a' : '#ffffff',
            borderRight: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)'}`,
          },
        },
      },
    },
  };
};

export const greentechThemeOptions = getGreentechThemeOptions('light');
